'use client'

import { MenuTrigger, Popover } from 'react-aria-components'

type ActionDropdownProps = {
  className?: string
  trigger: () => JSX.Element
  children: React.ReactNode
}

export default function ActionDropdown({
  className = '',
  trigger,
  children,
}: ActionDropdownProps): JSX.Element {
  return (
    <div className={className}>
      <MenuTrigger>
        {trigger ? trigger() : null}

        <Popover
          placement="bottom right"
          offset={10}
          className={`w-full max-w-[240px] bg-white drop-shadow-[0px_4px_24px_rgba(0,0,0,0.08)]`}>
          {children}
        </Popover>
      </MenuTrigger>
    </div>
  )
}
